import { inject } from '@angular/core';
import { CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, map, take } from 'rxjs';
import { AuthStore } from '@domains/auth/auth.store';

export const authGuard: CanActivateFn = (_route, state) => {
  const authService = inject(AuthStore);
  const router = inject(Router);

  if (!authService.isLoading()) {
    return authService.isAuthenticated()
      ? true
      : new RedirectCommand(router.parseUrl('/auth'), { state: { returnUrl: state.url } });
  }

  // Fallback
  return toObservable(authService.isLoading).pipe(
    filter((loading) => !loading),
    take(1),
    map(() =>
      authService.isAuthenticated()
        ? true
        : new RedirectCommand(router.parseUrl('/auth'), { state: { returnUrl: state.url } }),
    ),
  );
};
